<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->
<div mat-dialog-container>
  <div mat-dialog-title>
    Copying Scenario Events to ...
    <button mat-icon-button (click)="handleEditComplete(false)" title="Cancel" class="close-button" tabindex="-1">
      <mat-icon class="mdi-24px self-center" fontIcon="mdi-close-circle-outline"></mat-icon>
    </button>
  </div>
  @if (!!data && data.mselList) {
    <div mat-dialog-content>
      <div class="scenario-event-copy-dialog">
        <h4>Please select the destination MSEL.</h4>
        <mat-radio-group [(ngModel)]="selectedMselId">
          @for (msel of data.mselList; track msel.id) {
            <mat-radio-button [value]="msel.id">
              &nbsp;&nbsp;{{ msel.name }}
            </mat-radio-button>
            }<br />
          </mat-radio-group>
        </div>
      </div>
    }
    <div mat-dialog-actions>
      <button mat-stroked-button (click)="handleEditComplete(true)" [disabled]="selectedMselId === ''">Copy</button>
      <button mat-stroked-button (click)="handleEditComplete(false)">Cancel</button>
    </div>
  </div>